import styled from 'styled-components'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import {
  anatomyContainerCss,
  anatomyRootCss,
} from '~/pages/anatomy/libs/styles'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    ${anatomyContainerCss}
  `,

  Question: styled.h1`
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    color: ${COLORS.BLACK};
    margin-bottom: 24px;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
      line-height: ${ANATOMY_COMPACT.lineHeight.lh28};
      margin-bottom: ${ANATOMY_COMPACT.spacing.s24};
    }
  `,

  Grid: styled.div<{ $answersAtBottom?: boolean }>`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    ${({ $answersAtBottom }) => $answersAtBottom && 'margin-top: auto;'}
  `,

  OptionCard: styled.button<{ $isSelected: boolean }>`
    background: ${COLORS.WHITE};
    border: none;
    border-radius: 14px;
    overflow: hidden;
    cursor: pointer;
    padding: 0;
    text-align: start;
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    -webkit-tap-highlight-color: transparent;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 14px;
      border: 2px solid ${COLORS.PURPLE_500};
      opacity: ${({ $isSelected }) => ($isSelected ? 1 : 0)};
      transition: opacity 0.2s;
      pointer-events: none;
    }
  `,

  CardImage: styled.div`
    width: 100%;

    img {
      width: 100%;
      display: block;
    }
  `,

  CardLabel: styled.p`
    padding: 6px 10px 8px;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    color: ${COLORS.BLACK};
  `,
} as const
